module.exports = __webpack_public_path__ + "static/media/sf-test-1.cc3132ee.mp3";